module.exports = __webpack_public_path__ + "static/img/mix-data1.d61b1d85.svg";